<template>
  <div>
    <div class="text-center">
      <b-card-text class="mt-2 h4 color-inherit text-reset"> Invite User To Organisation</b-card-text>
    </div>
    <b-list-group class="mt-3 rounded-0">
      <b-list-group-item class="bg-transparent">
        <b-form-group :label="`Invitees (${invitedUsers.length})`" label-for="lb_search_user" />
        <div v-for="(user, index) in invitedUsers" :key="index" :invitedUsers="invitedUsers">
          <div class="employee-task d-flex justify-content-between align-items-center">
            <div class="media">
              <div class="media-body my-auto">
                <h6 class="mb-0">{{ user.email }}</h6>
                <small v-if="user.isOrgAmin">Organisatiom Admin</small>
                <br v-else />
              </div>
            </div>
            <div class="d-flex align-items-center icon-hover right-spacing">
              <BButton
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1 btn-remove-user"
                @click="removeUser(index)"
              >
                <FeatherIcon icon="UserMinusIcon" />
              </BButton>
            </div>
          </div>
        </div>
      </b-list-group-item>
      <hr />
      <b-row>
        <b-col md="12" class="mb-3 pl-1">
          <b-list-group-item class="bg-transparent">
            <b-form-group label="Search Users to Invite" label-for="input-email">
              <b-form-input id="input-email" v-model="email" :state="verifyEmail" type="email" placeholder="Your Email" />
              <b-form-invalid-feedback tooltip style="margin-left:1.2rem">
                Email address is invalid
              </b-form-invalid-feedback>
            </b-form-group>
          </b-list-group-item>
        </b-col>
      </b-row>
      <!-- <b-list-group-item class="bg-transparent">
        <b-form-group label="Search Users to Invite" label-for="lb_search_user">
          <b-form-input v-model="email" :state="verifyEmail" type="email" placeholder="Your Email" />
          <b-form-invalid-feedback tooltip>
            Email address is invalid
          </b-form-invalid-feedback>
          <small class="text-danger">Email address is invalid</small>
        </b-form-group>
      </b-list-group-item> -->
      <hr style="height: 0 !important;margin: 0; border: none;padding:0" />
      <b-list-group-item class="bg-transparent">
        <!-- <hr /> -->
        <!-- <b-form-group label="Search Users to Invite" label-for="lb_search_user" /> -->
        <!-- <SearchUser ref="searchUser" :hide-mail-icon="true" /> -->

        <div>
          <b-form-radio v-model="authority" name="some-radios" value="orgAdmin"> Organisation Admin</b-form-radio>
          <small class="text-secondary"
            >An administrator user who has access to the Admin Control panel and can view all content/users across their organisation</small
          >
          <b-form-radio v-model="authority" name="some-radios" value="user"> User</b-form-radio>
          <small class="text-secondary">A standard user who can access files and folders on MODV.</small>
        </div>
        <br />
        <BButton
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          :disabled="!email || authority === ''"
          variant="primary"
          @click="onClickAddUser()"
        >
          <FeatherIcon icon="UserPlusIcon" />
        </BButton>
        <hr />
      </b-list-group-item>
      <b-list-group-item class="bg-transparent right-align">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="mr-1"
          :disabled="invitedUsers.length === 0"
          @click="onClickInviteUser()"
        >
          Invite Users To Organisation
        </b-button>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive'
import { BCardText, BListGroup, BListGroupItem, BButton, BFormGroup, BFormRadio } from 'bootstrap-vue'
// import SearchUser from '@/components/SearchUser.vue'
import { mapState } from 'vuex'
// eslint-disable-next-line no-unused-vars
import { Notification } from 'element-ui'

export default {
  components: {
    BCardText,
    BListGroup,
    BListGroupItem,
    BButton,
    // SearchUser,
    BFormGroup,
    BFormRadio
  },
  directives: {
    Ripple
  },
  data: function() {
    return {
      name: '',
      email: '',
      authority: '',
      invitedUsers: [],
      adminEmails: [],
      userEmails: [],
      pendingAdminUsers: [],
      pendingUsers: [],
      pendingAdminUsersEmails: [],
      pendingUsersEmails: []
    }
  },
  computed: {
    ...mapState('search', ['searchUser']),
    ...mapState('homeAddNew', ['showNewEntityModal']),
    isUser: function() {
      return false
    },
    verifyEmail() {
      if (!this.email) return null
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(this.email)
    }
  },
  watch: {
    showNewEntityModal(nv, ov) {
      this.email = ''
      this.invitedUsers = []
      this.adminEmails = []
      this.userEmails = []
    }
  },
  created() {
    // this.invitedUsers = []
    // this.adminEmails = []
    // this.userEmails = []
  },
  mounted() {
    this.invitedUsers = []
    this.adminEmails = []
    this.userEmails = []
  },
  methods: {
    onClickAddUser() {
      const index = this.invitedUsers.findIndex(x => x.email === this.email)
      if (index >= 0) {
        Notification.error({
          title: 'User already listed.'
        })
      } else {
        const invite = {
          email: this.email,
          isOrgAmin: false
        }
        if (this.authority === 'orgAdmin') {
          invite.isOrgAmin = true
          this.adminEmails.push(invite)
        } else {
          this.userEmails.push(invite)
        }
        this.invitedUsers.push(invite)
        this.authority = ''
        this.$store.commit('search/CLEAR_QUERY')
      }
    },
    removeUser(index) {
      this.invitedUsers.splice(index, 1)
    },
    async onClickInviteUser() {
      if (this.adminEmails.length > 0) {
        this.adminEmails.forEach(email => {
          this.pendingAdminUsersEmails.push(email)
        })
      }
      if (this.userEmails.length > 0) {
        this.userEmails.forEach(email => {
          this.pendingUsersEmails.push(email)
        })
      }
      await this.$store.dispatch('homeAddNew/inviteUsers', {
        self: this,
        organisationId: this.$route.params.organisationId,
        pendingAdminUsers: this.pendingAdminUsersEmails,
        pendingUsers: this.pendingUsersEmails
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables/_variables';

.list-group-item {
  border: none !important;
}

.btn-add {
  height: 30px;
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
  margin-right: 0 !important;
  padding: 0.5rem;
}

.btn-remove-user {
  height: 30px;
  padding: 0.5rem;
  margin-right: 0 !important;
}

.card-title {
  margin-bottom: 0.2rem;
}

p {
  color: $text-muted;
}
</style>
